"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var linkHelper = function linkHelperFunction(href, external) {
  var cleanHref = href;
  var scrollToElement = RegExp('{scrollTo}').test(href);
  var forceNewTab = RegExp('{openNewTab}').test(href);
  var relativeUrl = RegExp('https://{relative}').test(href);
  var openNewTab = false;

  if (scrollToElement) {
    cleanHref = href.replace('https://{scrollTo}', '');
    openNewTab = false;
  }

  if (forceNewTab || external) {
    cleanHref = href.replace('{openNewTab}', '');
    openNewTab = true;
  }

  if (relativeUrl) {
    cleanHref = href.replace('https://{relative}', '');
    openNewTab = false;
  }

  return {
    cleanHref: cleanHref,
    openNewTab: openNewTab,
    scrollToElement: scrollToElement
  };
};

var _default = linkHelper;
exports["default"] = _default;